"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_jss_1 = require("react-jss");
const polished_1 = require("polished");
const _1 = require("../.");
/**
 * A button component to handle form actions, like submit or reset.
 */
const FormButton = ({ onClick, loading, children, }) => {
    const classes = useStyles();
    return (react_1.default.createElement("button", { type: 'button', className: classes.button, onClick: onClick, disabled: loading },
        loading && react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(_1.Loader, null),
            "\u00A0"),
        children));
};
const useStyles = (0, react_jss_1.createUseStyles)((theme) => ({
    button: {
        padding: `0 ${theme.sizes.inputHeight / 2}px`,
        fontSize: theme.typography.inputFontSize,
        lineHeight: `${theme.sizes.inputHeight}px`,
        height: theme.sizes.inputHeight,
        borderWidth: 0,
        borderRadius: theme.sizes.borderRadius,
        whiteSpace: 'nowrap',
        color: 'white',
        backgroundColor: theme.colors.accent,
        cursor: 'pointer',
        display: 'inline-flex',
        justifyContent: 'center',
        '&:hover': {
            backgroundColor: (0, polished_1.lighten)(0.1, theme.colors.accent),
        },
        '&:focus': {
            outline: 'none',
        },
        '&:disabled': {
            opacity: 0.6,
            pointerEvents: 'none',
        },
    },
}));
exports.default = FormButton;
